
import Vue from "vue";
import { Prop, Component, Watch } from "vue-property-decorator";

@Component
export default class InputField extends Vue {
  localValue = "";
  $refs!: {
    input: HTMLInputElement;
  };

  @Prop({ default: "name" })
  name: string;

  @Prop({ default: "" })
  value: string;

  @Prop({ default: "displayName" })
  placeholder: string;

  @Prop({ default: "" })
  rules: Object | string;

  @Prop({ default: "text" })
  type: string;

  @Prop({ default: "form-control form-control-sm" })
  customClass: string;

  @Prop({ default: "" })
  maxlength: string;

  @Prop({ default: null })
  error: Object;

  @Prop({ default: false })
  disabled: boolean;

  @Prop({ default: null })
  min: number;

  @Prop({ default: false })
  autofocus: boolean;

  @Prop({ default: null })
  step: string;

  @Prop({ default: true })
  showClear: boolean;

  get classObject() {
    return this.customClass;
  }
  get refName() {
    return `${this.name}_input`;
  }

  mounted() {
    this.localValue = this.value;
  }

  @Watch("localValue") 
  localValueChanged(newValue, oldValue) {
    if(newValue=="" && oldValue!="")
      this.update(newValue);
  }

  @Watch("value")
  valueChanged(newValue, oldValue) {
    this.localValue = newValue;
  }

  getValidationState({ dirty, validated, valid = null }) {
    return dirty || validated ? valid : null;
  }

  reset() {
    this.localValue = "";
  }

  update(value) {
    this.$emit("input", value);
  }

  focus() {
    this.$nextTick(() => this.$refs[this.refName].focus());
  }
}
